import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types'

import Opinion from '../components/wreck/Opinion';
import Profile from '../components/profile/Profile';

import { connect } from 'react-redux'
import { getOpinions } from '../redux/actions/dataActions'
import OpinionSkeleton from '../util/OpinionSkeleton'

class home extends Component {
    
    componentDidMount(){
        this.props.getOpinions()
    }

    render() {
        const { wrecks, loading } = this.props.data;
        let recentWrecksMarkup = !loading ? (
        wrecks.map(wreck => <Opinion wreck={wreck} key={wreck.wreckID} />)
        ) : ( 
            <OpinionSkeleton />
        )
        return (
            <div style={{padding: 12}}>
                <Grid container spacing={3} justify='center'>
                    <Grid item md={4} xs={8}> 
                        <Profile />   
                    </Grid>
                    <Grid item md={8} xs={12}>
                        {recentWrecksMarkup}    
                    </Grid>
                </Grid>
            </div>
        )
    }
}

home.propTypes = {
    getOpinions: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    data: state.data
})

export default connect(mapStateToProps, {getOpinions})(home)
